"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.braintreeOnClickGoogle = void 0;
const src_1 = require("../..");
function braintreeOnClickGoogle() {
    return __awaiter(this, void 0, void 0, function* () {
        const googlePayClient = (0, src_1.getBraintreeGooglePayClientChecked)();
        const paymentDataRequest = (0, src_1.braintreeCreatePaymentRequestGoogle)();
        try {
            yield googlePayClient.loadPaymentData(paymentDataRequest);
        }
        catch (e) {
            (0, src_1.displayError)('There was an unknown error while loading the wallet pay', 'generic', 'unknown_error');
            return;
        }
    });
}
exports.braintreeOnClickGoogle = braintreeOnClickGoogle;
